module.exports = __webpack_public_path__ + "img/shared-with-you-profile.9f078746.svg";